module.exports = __webpack_public_path__ + "static/media/iphone4.93218c5a.png";